<template>
	<div id="content" class="content">
	    <div class="content-wrap">
	        <h1>Seattle Collisions Visualization Blog</h1>
	        <div class="l-clearfix card">
	            <div class="card-content">
	                <div class="card-image"><a href="https://seattlecollisions.timganter.io/blog/hello-world/"><img src="https://seattlecollisions.timganter.io/blog/wp-content/uploads/2017/06/hello_world-150x150-1497327769.gif" alt="Hello world!" title="Hello world!"></a></div>
	                <h2><a href="https://seattlecollisions.timganter.io/blog/hello-world/">Hello world!</a></h2>
	                <p>Hello there! I figured I'd start blogging. The response from those that have seen this site has been very positive. I'm glad folks like it and are finding it useful. Seattle Greenways did a blog post on their site and cross posted on The
	                    Urbanist that looks at the cost of traffic violence. And this […]</p>
	            </div>
	        </div>
	    </div>
	</div>
</template>

<script>
export default {
  name: 'Blog'
}
</script>

<style lang="scss" scoped>
@import "../../sass/components/blog.scss";
</style>



// WEBPACK FOOTER //
// Blog.vue?0803e874